import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import BulkActionControl from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/OverclaimBulkActionControl'
import { observer } from 'mobx-react'

const AmendmentBulkAction = () => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)

    return (
        <>
            <BulkActionControl
                isSubmitDisabled={overclaimSearchBulkActionStore.idsSelectedForBulkAction.size === 0}
                submitButtonText="Start Bulk Share Amendment"
                submitButtonOnClick={() => overclaimSearchBulkActionStore.setIsAmendmentTableOpen(true)}
                instructions="Select all overclaims you wish to amend shares on, then click the Start Bulk Share Amendment."
                bulkSelectionCountText="share amendment"
            />
        </>
    )
}
export default observer(AmendmentBulkAction)
